var anchoredDivs = Array.from(document.querySelectorAll('.content div.component[id]'));
anchoredDivs.forEach(function (anchoredDiv) {
  var anchorLink = document.createElement('a');
  anchorLink.id = anchoredDiv.id;
  anchorLink.classList.add('anchor');
  anchoredDiv.id = "".concat(anchoredDiv.id, "_removed");
  anchoredDiv.parentElement.insertBefore(anchorLink, anchoredDiv);
});